export default {
    succText: 'Great!',
    finishButton: 'Complete',
    succSubText:
        'You have successfully completed this course. Once you have completed all courses of a contact point, you can try the final test.',
    noPoints: 'You have already passed the course once, so you will not get new points.'
}
